/*
 * Copyright (c) 2026. Tooling Team
 */

import { ML_PROBABILITY_COLUMN_KEY } from "./constants";

export const formatCellValue = (value) => {
  if (value === null || value === undefined) return "";
  if (Array.isArray(value)) return value.map(formatCellValue).join(", ");
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const formatConceptDetailValue = (value) =>
  formatCellValue(value) || "None";

export const getMiProbabilityValue = (value) => {
  const isPercentString = typeof value === "string" && value.includes("%");
  const numericValue =
    typeof value === "string" ? Number(value.replace("%", "").trim()) : value;
  if (!Number.isFinite(numericValue)) return null;
  return isPercentString ? numericValue / 100 : numericValue;
};

const truncateToTwoDecimals = (value) => Math.trunc(value * 100) / 100;

export const getMiProbabilityPercentage = (value) => {
  const isPercentString = typeof value === "string" && value.includes("%");
  const numericValue =
    typeof value === "string" ? Number(value.replace("%", "").trim()) : value;

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  if (isPercentString || numericValue > 1) {
    return Math.max(0, Math.min(100, numericValue));
  }

  return Math.max(0, Math.min(100, numericValue * 100));
};

export const formatMiProbabilityValue = (value, fallbackValue) => {
  const percentage = getMiProbabilityPercentage(value);
  if (percentage === null) {
    return fallbackValue ?? formatCellValue(value);
  }

  const displayPercentage =
    percentage >= 100 ? 99.99 : truncateToTwoDecimals(percentage);
  return `${displayPercentage.toFixed(2)}%`;
};

export const compareMiProbability = (rowA, rowB) => {
  const a = getMiProbabilityValue(rowA?.[ML_PROBABILITY_COLUMN_KEY]);
  const b = getMiProbabilityValue(rowB?.[ML_PROBABILITY_COLUMN_KEY]);
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return a - b;
};

export const getRowsSortedByMiProbability = (rows) =>
  [...rows].sort(compareMiProbability);
